import React from "react";

const HourlyPayrollCalendar = ({ includeDates, dailyHours, onHoursChange }) => {
  const [startDateString, endDateString] = includeDates.split("-");
  const startDate = new Date(Date.parse(startDateString.trim()));
  const endDate = new Date(Date.parse(endDateString.trim()));

  const days = [];
  for (
    let date = new Date(startDate);
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    days.push(new Date(date));
  }

  const startDayOfWeek = startDate.getDay();
  const weeks = [];
  let currentWeek = new Array(startDayOfWeek).fill(null);

  days.forEach((date) => {
    currentWeek.push(date);
    if (currentWeek.length === 7) {
      weeks.push(currentWeek);
      currentWeek = [];
    }
  });

  if (currentWeek.length > 0) {
    while (currentWeek.length < 7) {
      currentWeek.push(null);
    }
    weeks.push(currentWeek);
  }

  const weekDays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const calculateTotalHours = () => {
    return Object.values(dailyHours).reduce(
      (total, day) => total + (day.regular || 0),
      0
    );
  };

  const totalHours = calculateTotalHours();

  return (
    <div className="overflow-hidden rounded-sm border border-gray-200 bg-white">
      <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 px-6 py-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium text-white">Pay Period Calendar</h3>
          <p className="text-sm font-medium text-indigo-100">{includeDates}</p>
        </div>
      </div>
      <div className="isolate">
        <div className="shadow ring-1 ring-black ring-opacity-5">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {weekDays.map((day) => (
                  <th
                    key={day}
                    scope="col"
                    className="py-3.5 px-4 text-center text-sm font-medium text-gray-900">
                    {day}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {weeks.map((week, weekIndex) => (
                <tr key={weekIndex} className="divide-x divide-gray-200">
                  {week.map((date, dayIndex) => (
                    <td
                      key={dayIndex}
                      className={`relative p-3 ${
                        date ? "bg-white hover:bg-gray-50" : "bg-gray-50"
                      }`}>
                      {date ? (
                        <div className="space-y-2">
                          <div className="flex items-center justify-between">
                            <span className="text-sm font-medium text-gray-900">
                              {date.getDate()}
                            </span>
                            {dailyHours[new Date(date).toISOString().split("T")[0]]?.regular > 0 && (
                              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-50 text-xs font-medium text-indigo-600">
                                {dailyHours[new Date(date).toISOString().split("T")[0]]?.regular}
                              </span>
                            )}
                          </div>
                          <div className="space-y-1">
                            <input
                              type="number"
                              placeholder="Hours"
                              className="block w-full rounded-sm border-0 py-1.5 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                              value={
                                dailyHours[new Date(date).toISOString().split("T")[0]]
                                  ?.regular || ""
                              }
                              onChange={(e) =>
                                onHoursChange(date, "regular", e.target.value)
                              }
                            />
                            <input
                              type="text"
                              placeholder="Notes"
                              className="block w-full rounded-sm border-0 py-1.5 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                              value={
                                dailyHours[new Date(date).toISOString().split("T")[0]]
                                  ?.notes || ""
                              }
                              onChange={(e) =>
                                onHoursChange(date, "notes", e.target.value)
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="h-24" />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="border-t border-gray-200 bg-gray-50 px-6 py-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-700">Total Hours</span>
          <span className="text-lg font-semibold text-indigo-600">{totalHours}</span>
        </div>
      </div>
    </div>
  );
};

export default HourlyPayrollCalendar;
